<button
  id="fss-notification-alarm-button"
  (menuOpened)="closeSidenav()"
  [attr.aria-label]="menuButtonAriaLabel"
  class="notification-button"
  mat-icon-button
  [matMenuTriggerFor]="isUnEnabledForCurrentApp() && isMobile ? null : menu"
  #menuTrigger="matMenuTrigger"
  (click)="isUnEnabledForCurrentApp() && isMobile ? showInSidenav() : null"
  [class.un-btn]="isUnEnabledForCurrentApp()"
  >
  @if(isUnEnabledForCurrentApp()) {
    <fa-icon class="bell-icon" [icon]="['fal', 'bell']"></fa-icon>
    <fa-icon class="bell-icon-hover" [icon]="['fas', 'bell']"></fa-icon>
  } @else {
    <mat-icon [svgIcon]="icons.ALARM_BELL" title="Notifications"></mat-icon>
  }
  @if (unreadCount > 0) {
    <span class="notification-count" [class.un-count]="isUnEnabledForCurrentApp()">
      {{ unreadCount > 9 ? '9+' : unreadCount }}
    </span>
  }
</button>

<mat-menu id="fss-notifications-menu" #menu="matMenu" class="fss-notifications-menu fss-disable-default-mat-menu-item">
  <ng-template #notificationsTemplate>
    <div [class.un]="isUnEnabledForCurrentApp()">
      <div
        cdkTrapFocus
        [cdkTrapFocusAutoCapture]="true"
        (click)="$event.stopPropagation()"
        (keydown.tab)="$event.stopPropagation()"
        (keydown.shift.tab)="$event.stopPropagation()"
        class="notification-container"
        [ngClass]="{
          'notification-container-empty': allNotifications.length === 0
        }"
        >
        <div id="notifications-header" class="notifications-header">
          <span class="notifications-title">Notifications</span>
          @if (isUnEnabledForCurrentApp() && displayableNotifications.length > 0) {
            <button (click)="markAllAsRead()" class="mark-all-btn">Mark all as read</button>
          }
        </div>

        @if (displayableNotifications.length > 0) {
          @if (!isUnEnabledForCurrentApp()) {
            <div id="fss-notifications-subheader" class="subheader">
              <div id="fss-notifications-subheader-buttons" class="message-toggle-button-group">
                <button
                  mat-menu-item
                  cdkFocusInitial
                  id="fss-notifications-all-btn"
                  class="message-toggle-button"
                  [ngClass]="{ 'message-toggle-button-active': !showUnreadOnly }"
                  (click)="clickNotificationFilter(notificationFilter.ALL)"
                  attr.aria-label="Display all notifications, {{ allNotifications.length }} total."
                  type="button"
                  >
                  All ({{ allNotifications.length }})
                </button>
                @if (unreadCount > 0) {
                  <button
                    mat-menu-item
                    id="fss-notifications-unread-btn"
                    class="message-toggle-button"
                    [ngClass]="{ 'message-toggle-button-active': showUnreadOnly }"
                    (click)="clickNotificationFilter(notificationFilter.UNREAD)"
                    attr.aria-label="Display only unread notifications, {{ unreadCount }} total."
                    type="button"
                    >
                    Unread ({{ unreadCount }})
                  </button>
                }
              </div>
            </div>
          }
          <div id="fss-notifications-messages" class="messages __scroll">
            @for (notification of displayableNotifications; track notification.id; let last = $last) {
              <button
                id="fss-notifications-message-{{ notification.id }}"
                class="message-button"
                type="button"
                [ngClass]="{ 'message-unread': notification.new, 'message-unread-destiny': notification.new && isUsingDestinyTheme() }"
                (click)="clickNotification(notification)"
                mat-menu-item
                >
                <div class="message-content">
                  @if (!isUnEnabledForCurrentApp()) {
                    <span>
                      <mat-icon [svgIcon]="getNotificationIcon(notification)" class="message-icon"></mat-icon>
                    </span>
                  }
                  <div class="message-container">
                    @if (!isUnEnabledForCurrentApp()) {
                      <div id="fss-notifications-message-{{ notification.id }}-title" class="message-title">
                        {{ notification.title }}
                      </div>
                    }
                    <div id="fss-notifications-message-{{ notification.id }}-description" class="message-description">
                      @if (isUnEnabledForCurrentApp()) {
                        <span>{{ notification.title }}</span>
                      }
                      {{ notification.description }}
                    </div>
                    <div id="fss-notifications-message-{{ notification.id }}-date" class="message-date">
                      @if (notification.createdDate) {
                        <span>{{ notification.createdDate | date: "yyyy-MM-dd" }}</span>
                      }
                      @if (notification.createdDate) {
                        <span> - </span>
                      }
                      <span>{{ getSourceDescription(notification) }}</span>
                    </div>
                  </div>
                </div>
              </button>
              @if (isUnEnabledForCurrentApp() && !last) {
                <mat-divider></mat-divider>
              }
            }
          </div>
        } @else {
          <div class="no-notifications">
            <span class="no-notifications-msg" id="no-notifications-msg">
              @if (isUnEnabledForCurrentApp()) {
                <fa-icon [icon]="['far','bell-slash']"></fa-icon>
                No new notifications
              } @else {
                There aren't any notifications to review at this time.
              }
            </span>
          </div>
        }


        @if (isUnEnabledForCurrentApp()) {
          <div class="show-read-notifications">
            <mat-slide-toggle
              (change)="toggleNotificationFilter()"
              [checked]="!showUnreadOnly"
              disableRipple
              hideIcon
              class="show-read-notifications-toggle"
              >
            </mat-slide-toggle>
            Show read notifications
          </div>
        }
      </div>
    </div>
  </ng-template>
  <ng-container [ngTemplateOutlet]="notificationsTemplate"></ng-container>
</mat-menu>
